import { ChatRoomStatus } from '@/types/schema.generated'

export const chatRoomStatusString: Record<ChatRoomStatus, string> = {
  [ChatRoomStatus.NotDefined]: '未設定',
  [ChatRoomStatus.Messaging]: 'チャット対応中',
  [ChatRoomStatus.Offering]: '面談設定中',
  [ChatRoomStatus.Appointed]: '面談済み・対応中',
  [ChatRoomStatus.ContractConcluded]: '契約済み',
  [ChatRoomStatus.Keeping]: '後追い対応',
  [ChatRoomStatus.Archived]: '対応不要',
  [ChatRoomStatus.ContractConcludedSecurities]: '証券契約済み',
  [ChatRoomStatus.ContractConcludedInsurance]: '保険契約済み',
  [ChatRoomStatus.GotComplaints]: '不満足の表明',
  [ChatRoomStatus.LostOrder]: '失注',
  [ChatRoomStatus.ActionRequired]: '要対応',
  [ChatRoomStatus.WaitingForFirstAppointment]: '初回面談実施待ち',
}

export const allChatRoomStatuses: ChatRoomStatus[] = [
  ChatRoomStatus.NotDefined,
  ChatRoomStatus.Messaging,
  ChatRoomStatus.Offering,
  ChatRoomStatus.WaitingForFirstAppointment,
  ChatRoomStatus.Appointed,
  ChatRoomStatus.Keeping,
  ChatRoomStatus.ContractConcludedSecurities,
  ChatRoomStatus.ContractConcludedInsurance,
  ChatRoomStatus.ContractConcluded,
  ChatRoomStatus.GotComplaints,
  ChatRoomStatus.ActionRequired,
  ChatRoomStatus.LostOrder,
  ChatRoomStatus.Archived,
]
